import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { APP_MODEL_DATA } from '../model-data/app-model-data';
import { NgxSpinnerService  } from "ngx-spinner";
import { ISuccessError,ICommonModalBody,ICommonModal} from '../interface-model/app-interface-model';
import { environment } from 'src/environments/environment';
import { AbstractControl } from '@angular/forms';
import { LocalStorageService } from './local-storage.service';
import { bool } from 'aws-sdk/clients/signer';

@Injectable({
  providedIn: 'root'
})

export class UtilService {

  public hideHeader = new BehaviorSubject<boolean>(false);
  public showNavigationBar = new BehaviorSubject<boolean>(true);
  public getAuthcode = new BehaviorSubject<string>("");
  public getSignedInMessage = new BehaviorSubject<boolean>(false);
  public enableEditUser = new BehaviorSubject<boolean>(false);
  public enableCreateUser = new BehaviorSubject<boolean>(false);
  public isUpdateFirmware = new BehaviorSubject<boolean>(false);
  public usertypes = new BehaviorSubject<Array<any>>([]);
  public successErrorModal = new BehaviorSubject<ISuccessError>({} as any);
  public commonModal = new BehaviorSubject<ICommonModal>({} as any);  
  userTypesList: any;

  constructor(private router: Router, 
    public activatedRoute: ActivatedRoute, 
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private localStorageService : LocalStorageService
 ) { }

 noWhitespaceValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const isWhitespace = (control.value || '').trim().length === 0;
  return isWhitespace ? { 'whitespace': true } : null;
}

  getLangFromParam(val: string) {
    if (APP_MODEL_DATA.SUPPORTED_LANG_TRANSLATIONS.includes(val.toLocaleLowerCase())) {
        return val.toLocaleLowerCase();
    } else {
        return 'en';
    }
  }

  getUrlParams() {
    let urlParams: any;
    this.activatedRoute.queryParams
      .subscribe(params => {
        urlParams = params;
      }
    );

    return urlParams;
  }

  checkLanguageConstraintForApp() {
    this.translate.addLangs(APP_MODEL_DATA.SUPPORTED_LANG_TRANSLATIONS);
    let currentLanguage = this.localStorageService.getItem("language");
    let params = this.getUrlParams();
    if (params["lang"] === undefined) {
      let lang = currentLanguage ? currentLanguage : 'en';
      this.localStorageService.setItem("language", lang);
      this.translate.setDefaultLang(lang);
      this.translate.use(lang)
    }
  }

  checkLanguageConstraintForSignIn() {
   let currentLanguage = this.localStorageService.getItem("language")?.toLocaleLowerCase();
    let params = this.getUrlParams();
    if (params["lang"] === undefined || this.getLangFromParam(params["lang"]) !== currentLanguage || this.getLangFromParam(params["lang"]) == currentLanguage) {
      let lang = (params["lang"] === undefined)? currentLanguage || 'en' : this.getLangFromParam(params["lang"]) || currentLanguage || 'en';
      this.localStorageService.setItem("language", lang);
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
      this.router.navigate(["/sign-in"],{queryParams:{"lang": lang}});
    }
  }
  clearStorage() {
    document.cookie = 'refreshToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'idToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    this.localStorageService.clear();
  }
  parseJwt(token: string) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload.replace("cognito:username","user_id"));
  }
  getToken(getCookieName: string) {
    let cookieName = getCookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookieData = cookieArray[i];
        while (cookieData.charAt(0) == ' ') {
            cookieData = cookieData.substring(1);
        }
        if (cookieData.indexOf(cookieName) == 0) {
            return cookieData.substring(cookieName.length, cookieData.length);
        }
    }
    return "";
}
signout()
{
  this.clearStorage();
  this.router.navigate(["/sign-in"]);
}

disableUserCheck(data: any){
  if(data.error.message=='log_disabled_user')
  {
      let successErrorData: ISuccessError ={modalTitle:'Error',isError:true,navigateTo:'/sign-in',langKey:'lang.log_disabled_user',isLangKey:true};
      this.successErrorModal.next(successErrorData);
  }
}

commonErrorHandler(getErrorHandlerData: any) {
  
  // Handling specific error based on the HTTP status code received in getErrorHandlerData
  
  if (getErrorHandlerData.status == 400) {

    // Handle 400 Bad Request
    // This usually indicates that the request was malformed or contains invalid parameters.
    // Add custom handling or error messaging here, such as displaying a validation message.

    let successErrorData: ISuccessError = {
      modalTitle: 'Error',
      isError: true,
      navigateTo: '',
      langKey: getErrorHandlerData.error.error.reason ? getErrorHandlerData.error.error.reason : 'lang.something_went_wrong', // Error message from the server
      isLangKey: true
    };
    
    // Show the error modal to inform the user that the requested resource was not found.
    this.successErrorModal.next(successErrorData);

    console.error('Bad Request (400): The request could not be understood by the server due to malformed syntax.');

  } else if (getErrorHandlerData.status == 401) {

    // Handle 401 Unauthorized
    // Typically occurs when the user is not authenticated or the session has expired.
    // We clear the local storage to remove any stale session data and navigate the user to the sign-in page.

    this.clearStorage();
    
    let successErrorData: ISuccessError = {
      modalTitle: 'Error',
      isError: true,
      navigateTo: '/sign-in',
      langKey: 'lang.authorization_required', // Translated message for "Authorization required"
      isLangKey: true
    };
    
    // Trigger the modal to notify the user about the unauthorized state and redirect them to login.
    this.successErrorModal.next(successErrorData);

  } else if (getErrorHandlerData.status == 403) {

    // Handle 403 Forbidden
    // This happens when the user does not have the required permissions to access the resource.
    // Here, the session is cleared, and we invoke a method to disable user access or notify them.

    this.clearStorage();

    let successErrorData: ISuccessError = {
      modalTitle: 'Error',
      isError: true,
      navigateTo: '/sign-in',
      langKey: 'lang.log_disabled_user',
      isLangKey: true
    };
    
    this.successErrorModal.next(successErrorData);
    
    console.error('Forbidden (403): The server understood the request, but the user does not have the required permissions.');

  } else if (getErrorHandlerData.status == 404) {

    // Handle 404 Not Found
    // Indicates that the requested resource could not be found on the server.
    // A user-friendly message is displayed, and the user is redirected to a specific page.

    let successErrorData: ISuccessError = {
      modalTitle: 'Error',
      isError: true,
      navigateTo: '',  //Add navigation logic in respective component if required
      langKey: getErrorHandlerData.error.error?.reason  || getErrorHandlerData?.error?.message ||'lang.something_went_wrong', // Error message from the server
      isLangKey: true
    };
    
    // Show the error modal to inform the user that the requested resource was not found.
    this.successErrorModal.next(successErrorData);
    console.error('Not Found (404): The requested resource could not be found on the server.');

  } else if (getErrorHandlerData.status == 409) {

    // Handle 409 Conflict
    // This status occurs when there is a conflict with the current state of the resource,
    // for example, trying to create a resource that already exists
    console.error('Conflict (409): There was a conflict with the current state of the resource.');

    // Custom logic for handling conflicts handled at the component level.
  
  } else if (getErrorHandlerData.status == 500) {
    // Handle 500 Internal Server Error
    // This occurs when the server encounters an unexpected condition that prevents it from fulfilling the request.
    console.error('Internal Server Error (500): The server encountered an unexpected condition.');
    // Add logic here to either retry the request or notify the user.
    
  } else {
    // Generic error handling for any other status codes that are not explicitly handled.
    // This covers cases like network issues or unexpected server responses.
    let successErrorData: ISuccessError = {
      modalTitle: 'Error',
      isError: true,
      navigateTo: '',
      langKey: 'lang.something_went_wrong', // Generic error message key for "Something went wrong"
      isLangKey: true
    };
    
    // Display a generic error modal for unknown or unexpected errors
    this.successErrorModal.next(successErrorData);
    console.error('An unexpected error occurred.');
  }
}

commonErrorHandler1(getErrorHandlerData: any){
  if (getErrorHandlerData.status == 403) {
    this.clearStorage();
    this.disableUserCheck(getErrorHandlerData.error);
  } 
  else if (getErrorHandlerData.status == 401) {
    this.clearStorage();
    let successErrorData: ISuccessError = {modalTitle:'Error',isError:true,navigateTo:'/sign-in',langKey:'lang.authorization_required',isLangKey:true};
    this.successErrorModal.next(successErrorData);
  }
  else if (getErrorHandlerData.status == 404) {
    let successErrorData: ISuccessError = {modalTitle:'Error',isError:true,navigateTo:'/equipment/list',langKey:'' + getErrorHandlerData.error.body.error.message ,isLangKey:true};
    this.successErrorModal.next(successErrorData);
  }else if(getErrorHandlerData.status == 409) {
      // This error case, when adding a controller to a site, will be handled within that component.
  }
   else {
    let successErrorData: ISuccessError;
    if(getErrorHandlerData.error.messages)
    {
      successErrorData= {modalTitle:'Error',isError:true,navigateTo:'',langKey:'lang.' + getErrorHandlerData.error.messages[0].text.toLocaleLowerCase(),isLangKey:true};
      this.successErrorModal.next(successErrorData);
    }
    if(getErrorHandlerData.error.message)
    {
      successErrorData= {modalTitle:'Error',isError:true,navigateTo:'',langKey:getErrorHandlerData.error.message,isLangKey:false};
      this.successErrorModal.next(successErrorData);
    }
    else if(getErrorHandlerData.error.message){
      successErrorData = { modalTitle: 'Error', isError: true, navigateTo: '', langKey: '' + getErrorHandlerData.error.message, isLangKey: false };
      this.successErrorModal.next(successErrorData);
    }else if(getErrorHandlerData.error.error.reason)
      {
      successErrorData = { modalTitle: 'Error', isError: true, navigateTo: '', langKey: '' + getErrorHandlerData.error.error.message, isLangKey: false };
      this.successErrorModal.next(successErrorData);
    }
    else
    {
      successErrorData= {modalTitle:'Error',isError:true,navigateTo:'',langKey:"",isLangKey:false};
      this.successErrorModal.next(successErrorData);
      
    }
    
  }
}

expriySessionCheck(): any{
  let commonModalBodyData: ICommonModalBody[]=[];
  commonModalBodyData.push({content:'lang.exp_session',commonModalHrefLink:''},{content:'',commonModalHrefLink:'sign-in'},{content:'lang.continue_session',commonModalHrefLink:''});
  let commonModalData: ICommonModal = {commonModalBody:commonModalBodyData,isCommonModalButton:false}
  return commonModalData
}
loginAgainCheck(): any{
  let commonModalBodyData: ICommonModalBody[]=[];
  commonModalBodyData.push({content:'lang.login_again',commonModalHrefLink:''});
  let commonModalData: ICommonModal = {commonModalBody:commonModalBodyData,isCommonModalButton:true}
  return commonModalData
}
exchangeErrorCheck(exchangeError:string): any{
  let commonModalBodyData: ICommonModalBody[]=[];
  commonModalBodyData.push({content: exchangeError,commonModalHrefLink:''});
  let commonModalData: ICommonModal = {commonModalBody:commonModalBodyData,isCommonModalButton:true}
  return commonModalData
}

showSpinner(name:string): void{
  this.spinner.show(name);
}

hideSpinner(name:string): void{
  this.spinner.hide(name);
}

setLocalStorage(key:string,value:any)
{
  this.localStorageService.setItem(key,value);
}

getLocalStorage(key:string)
{
  return this.localStorageService.getItem(key);
}

scrollToTarget(elementID: any) 
{
  let element = document.getElementById(elementID);
  let headerOffset = 45;
  if (element) {
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

hasTranslationKey(key: string): boolean {
  const translation = this.translate.instant(key);
  return translation !== key && translation !== '';
}

  removeItemLocalStorage(key:string)
  {
    this.localStorageService.removeItem(key);
  }

  getPropertyValWithGetHomeResponse(getHomeResponse:any, propertyName: string) {
    let propertyValue = "";
    getHomeResponse.forEach((obj:any) => {
        if(obj[propertyName]){
            propertyValue = obj[propertyName];
        }
    });
    return propertyValue;
  }

    convertToCamelCase(text: string): string {
    if (!text.includes(" ")) {
      return text;
    }

    return text
      .trim().toLowerCase().split(/\s+/).map((word, index) =>
        index === 0
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join("");
  }

  normalizeEquipmentType(type: string | null | undefined): string {
    if (!type) {
      return '';
    }

    const normalized = this.convertToCamelCase(type.trim());
    const aliases: Record<string, string> = {
      airTempSensor: 'airtempSensor',
      waterTempSensor: 'watertempSensor',
      solarTempSensor: 'solartempSensor',
      flowRateMeter: 'flowRate',
      Sanitizer: 'sanitizer', // Bothe sanitizer and sanitizerGen2 have category sanitizer, so no extra map needed for sanitizerGen2
    };

    return aliases[normalized] ?? normalized;
  }

  // Convert future timestamp to remaining time in HH:MM:SS format
  formatRemainingHHMMSS(endTimestampMs: number): string {
    const now = Date.now();
    const diffMs = Math.max(0, endTimestampMs - now);
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }
}
